module.exports = __webpack_public_path__ + "static/media/searchIcon.db812135.svg";